import { useMutation } from "react-query";
import { createApiWithPath } from "../../client";
import { StoryInteractionStatus } from "../../types/story-interactions";

interface UpdateStoryInteractionStatusPayload {
  id: string;
  status: StoryInteractionStatus;
}

export const useUpdateStoryInteractionStatus = () => {
  return useMutation(async (payload: UpdateStoryInteractionStatusPayload) => {
    const response = await createApiWithPath("story-interactions").patch(
      `/${payload.id}`,
      {
        status: payload.status,
      },
    );
    return response.data;
  });
};
